export const companyImportCSV = [
    "type",
    "category",
    "email",
    "notes",
    "pan_number",
    "legal_name",
    "ledger_name",
    "agent_ledger_name",
    "address_1_state",
    "address_1_line1",
    "address_1_email",
    "address_1_city",
    "address_1_country",
    "address_1_gstin",
    "address_1_branch_name",
    "address_1_landline_number",
    "address_1_pincode",
    "address_1_transport_delivery_station",
    "address_1_transport_name"
]

export const contactImportCSV = [
    "name",
    "status",
    "role_permission_name",
    "notes",
    "designation",
    "company_ledger_name",
    "user_phone_number",
]

export const productImportCSV = [
    "name",
    "sku_id",
    "description",
    "uom",
    "minimum_order_quantity",
    "available_quantity",
    "features",
    "material",
    "status",
    "cost_price",
    "rating_stars",
    "review_count",
]
